export interface ImageInstance {
  width: number;
  height: number;
  src: string;
}
